import { EOBManagement } from 'pages/eobs';

import { Unauthorized } from 'components/unauthorized';

import { useCanAccess } from 'hooks/useCanAccess';
import { TokenExpired } from 'components/tokenExpired';

export const EOBManagementRoute = () => {
  const { isAdmin, isExpired } = useCanAccess('eobs');

  return isExpired ? (
    <TokenExpired />
  ) : isAdmin ? (
    <EOBManagement />
  ) : (
    <Unauthorized />
  );
};
